module.exports = __webpack_public_path__ + "static/img/product5.1f24183.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product5.png
// module id = Lj6t
// module chunks = 0